import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  PAYMENT_FOR_TYPE,
  storeContentKeys,
  SUBSCRIPTION_TYPE,
  vipOfferFieldsKey
} from '@constants/constant';
import { API_URLS } from '@core/api-url.enum';
import { Application } from '@enums/application.enums';
import { appRoutingUrl } from '@enums/comman.enums';
import { UnlockedBy } from '@enums/messages.enums';
import { Labels } from '@modules/shared/components/vip-offer-list/constant';
import { CommonService } from '@modules/shared/services/common.service';
import { ApiCallService } from '@services/api-call.service';
import { LoginDialogComponent } from '@shared/components/login-dialog/login-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '@core/auth.service';
import { PermissionService } from '@shared/services/permissions.service';
import { AllAvailablePlansModalComponent } from '@components/all-available-plans-modal/all-available-plans-modal.component';
import { ALL_AVAILABLE_PLANS_LABELS } from '@components/all-available-plans-modal/constants';

@Component({
  selector: 'app-unlock-content',
  templateUrl: './unlock-content.component.html',
  styleUrls: ['unlock-content.component.scss'],
  host: { class: 'unlock-content-component' }
})
export class UnlockContentComponent implements OnInit {
  @Input() lockDetails;
  @Input() userProfile;
  @Input() contentId;
  @Input() contentType;
  @Input() userId;
  @Input() userSubscriptionList;
  @Input() queryParams;
  @Input() redirectURL;
  @Input() forceLockType: boolean = false;
  @Input() checkLockForDownloadable: boolean = false;
  @Input() headerType = '';
  @Input() isLocked: boolean = true;
  @Input() isAllowedToUnlock =  true;
  @Input() isAllowedToRedirect = true;
  @Input() isIndividualPortfolio = false;
  @Input() portfolioTypeId = '';
  @Input() userName = '';
  @Input() isLivestreamContext = false;

  @ViewChild('unlockOptions') unlockOptionsModal;
  @ViewChild('nftUnlock') nftUnlockModal;

  @Output() closePreviousModal = new EventEmitter<any>();
  label = '';
  labels = Labels;
  lockFields = vipOfferFieldsKey;
  isLockEnabled = false;
  headerLabel = '';
  unlockDescription = '';

  constructor(
    private readonly apiCallService: ApiCallService,
    public readonly cs: CommonService,
    private readonly router: Router,
    private readonly modalService: BsModalService,
    private readonly authService: AuthService,
    private readonly ps: PermissionService
  ) { }

  unlockStatusData: { message: any };
  ngOnInit() {
    if (this.cs.isBrowser) {
      let buyer_text;
      if (this.lockDetails?.is_subscription && this.lockDetails?.is_nft) {
        buyer_text = 'Subscribers or NFT Holders';
      } else if (this.lockDetails?.is_subscription) {
        buyer_text = 'Subscribers';
      } else {
        buyer_text = 'NFT Holders';
      }

      this.label = Labels.UNLOCK_ABILITY_TO_PURCHASE;
      const ModalMessageType = this.headerType || this.contentType;
      const formattedContent = ModalMessageType.toLowerCase() === 'nft' ? ModalMessageType.toUpperCase() : ModalMessageType;

      this.headerLabel = Labels.RESTRICTED_CONTENT.replace(
        '<content>',
        formattedContent
      );

      this.unlockDescription = Labels.CONTENT_IS_ONLY_AVAILABLE_TO.replace(
        '<content>',
        formattedContent
      ).replace(
        '<buyer_text>',
        buyer_text
      );
    }
  }

  ngOnChanges(changes) {
    if (
      changes['contentId'] ||
      changes['userProfile'] ||
      changes['lockDetails']
    ) {
      if (
        (this.forceLockType ||
          this.lockDetails?.is_nft ||
          this.lockDetails?.is_individual_price ||
          this.lockDetails?.is_subscription)
      ) {
        if(this.contentType !== PAYMENT_FOR_TYPE.NEWSLETTER 
            && this.contentType !== PAYMENT_FOR_TYPE.MUSIC_PORTFOLIO)
          {
            this.checkSubscriptionStatus();
            if(!this.isAllowedToUnlock) {
              this.isLocked = true;
            }
          }
      } else {
        this.isLocked = false;
      }
    }
    if (changes['userSubscriptionList']) {
      if (this.userSubscriptionList?.length) {
        this.userSubscriptionList?.sort((a, b) => {
          return a.duration - b.duration;
        });
      }
    }
  }
  showUnlockingOptions() {
    if (this.authService.isAuthenticated()) {
      this.cs.liveStreamShareModalClose$.next({hide: true});
      const cb = () => {
        this.unlockOptionsModal?.openModal();
      };
      this.ps.checkDelegateUserPermission(cb.bind(this));
    } else {
      this.loginDialog();
    }
  }

  loginDialog() {
    this.modalService.show(LoginDialogComponent, {
      initialState: Object.assign({ status: false })
    });
  }

  handleOptionsCancel() {
    this.unlockOptionsModal?.closeModal();
  }

  openAllAvailablePlansModal() {
    const cb = () => {
      const contentKey = storeContentKeys[this.contentType];
      const subscriptionPaymentData: Record<string, unknown> = {
        callType: PAYMENT_FOR_TYPE.STORE_CONTENT,
        contentKey,
        user: this.userProfile
      };
      if (!this.checkLockForDownloadable) {
        subscriptionPaymentData[contentKey] = this.contentId;
      }

      let paymentRouteQueryParams;
      if (this.isIndividualPortfolio && this.userName && this.portfolioTypeId) {
        paymentRouteQueryParams = {
          queryParams: {
            redirect: PAYMENT_FOR_TYPE.MUSIC_PORTFOLIO,
            url: `/dashboard/portfolio/${this.userName}/banner-view/${this.portfolioTypeId}`
          }
        };
      } else {
        paymentRouteQueryParams = {
          queryParams: {
            redirect: PAYMENT_FOR_TYPE.STORE_CONTENT,
            url: PAYMENT_FOR_TYPE.STORE_CONTENT
          }
        };
      }

      const lockedSubscriptions =
        this.lockDetails?.subscription ||
        this.lockDetails?.locked_through?.subscription ||
        this.lockDetails?.locked_through?.individual?.outer_subscription;

      this.modalService.show(AllAvailablePlansModalComponent, {
        initialState: {
          userId: this.userProfile?.user_name,
          lockedSubscriptions,
          headerLabel: ALL_AVAILABLE_PLANS_LABELS.UNLOCK_CONTENT,
          isUnlockingContent: true,
          isLivestreamPayment: !this.isAllowedToRedirect,
          subscriptionPaymentData,
          paymentRouteQueryParams
        },
        class: 'all-available-plans-modal-wrapper',
        backdrop: 'static'
      });
    };
    this.ps.checkDelegateUserPermission(cb.bind(this));
  }

  checkSubscriptionStatus() {
    if (this.userProfile?.gsi4pk && this.contentId && this.isAllowedToUnlock) {
      this.isLocked = !this.lockDetails?.lock_status?.is_unlocked && !this.lockDetails?.lock_status?.is_outer_unlocked;
      if (!this.isLocked) {
        this.unlockStatusData = {
          message: UnlockedBy[this.lockDetails.lock_status.unlocked_by]?.replace(
            '<content>',
            this.contentType
          )
        };
      }
    }
  }

  lockContentSelected(lock, type) {
    switch (type) {
      case vipOfferFieldsKey.SUBSCRIPTION:
        this.openAllAvailablePlansModal();
        break;
      case vipOfferFieldsKey.LOCK_NFT:
        this.nftUnlockModal?.openModal();
        break;
      case vipOfferFieldsKey.INDIVIDUAL_PURCHASE:
        const data = {
          [storeContentKeys[this.contentType]]: this.contentId,
          type: SUBSCRIPTION_TYPE.INDIVIDUAL,
          plan_id: '',
          plan_user_id: `USER#${this.userProfile.gsi4pk}`,
          amount: lock.individual_price,
          plan_discount: Application.ZERO,
          user: this.userProfile,
          contentKey: storeContentKeys[this.contentType]
        };
        if (this.isAllowedToRedirect) {
          this.goToPaymentPage(data);
        } else {
          this.cs.liveStreamPaymentInitiate.next(data);
          this.closePreviousModal.emit();
        }
        break;
    }
    this.handleOptionsCancel();
  }

  goToPaymentPage(paymentData) {
    if (this.checkLockForDownloadable) {
      delete paymentData[storeContentKeys[this.contentType]];
    }
    this.apiCallService
      .post(API_URLS.subscribeUserPlan, paymentData, true)
      .subscribe({
        next: (res) => {
          if (res.status) {
            this.closePreviousModal.emit();
            this.cs.subscriptionPaymentData.next({
              ...paymentData,
              orderSK: res.data?.orderSK,
              callType: PAYMENT_FOR_TYPE.STORE_CONTENT
            });
            if(this.contentType === PAYMENT_FOR_TYPE.MUSIC_PORTFOLIO)
              this.modalService.hide();
            if(this.isIndividualPortfolio && this.userName && this.portfolioTypeId) {
                this.router.navigate([appRoutingUrl.DASHBOARD_PAYMENT], {
                  queryParams: {
                    redirect: PAYMENT_FOR_TYPE.MUSIC_PORTFOLIO,
                    url: `/dashboard/portfolio/${this.userName}/banner-view/${this.portfolioTypeId}`
                  }
                });
            } else {
              this.router.navigate([appRoutingUrl.DASHBOARD_PAYMENT], {
                queryParams: {
                  redirect: PAYMENT_FOR_TYPE.STORE_CONTENT,
                  url: PAYMENT_FOR_TYPE.STORE_CONTENT
                }
              });
            }
          }
        },
        error: (err) => {
          this.cs.showErrorMessage(err.message);
        }
      });
  }

  confirmNftOffer() {
    this.handleCancel();
    this.nftUnlockModal?.closeModal();
    this.closePreviousModal.emit();
  }

  handleCancel(clearData = true) {
    if (clearData) {
      this.cs.liveStreamShareModalClose$.next(true);
    }
  }

  get isLockType(): boolean {
    return (
      this.forceLockType ||
      this.lockDetails?.is_nft ||
      this.lockDetails?.is_individual_price ||
      this.lockDetails?.is_subscription
    );
  }
}
